export function removeSplash() {
  const el = document.getElementById('app-splash');
  if (!el) return;
  el.classList.add('hidden');
  setTimeout(() => el.remove(), 250);
}
